import { language, request } from '@tencent/ppd-base-libs';
import { cacheFunc, getConfigWithLang, to } from '@tencent/wphk-base-utils';
import { C2CConfig } from '../types';

/** 获取商户配置 - 货源配置系统商户配置 */
const getC2CConfig = cacheFunc(() => request.loadConfig('https://st.moneydata.hk/wuji/config/c2c/c2c.json'));

/** 加载配置，对错误静默处理 */
const promiseGetConfig = async () => {
  const [err, res] = await to(getC2CConfig());
  if (err || !res) {
    return [];
  }
  return res;
};

/** 格式化原始配置 */
const formatConfig = (conf): C2CConfig[] => getConfigWithLang(conf, language.getLanguage()) as C2CConfig[];

/**
 * 加载配置
 */
export async function loadC2CConf(): Promise<C2CConfig[]> {
  const rawConf = await promiseGetConfig();
  return formatConfig(rawConf);
}
